import { SITE_TRUST_STATS } from './siteTrustStats';
import { SITE_BRAND_NAME } from '../constants/siteBranding';

/** Static content for /client-reviews-ahmedabad (SEO + UI). */
export const CLIENT_REVIEWS_STATS = SITE_TRUST_STATS.map((s) => ({
  ...s,
  emoji: '⭐'
}));

export const CLIENT_TESTIMONIALS = [
  {
    id: 'smit-gandhi',
    name: 'Smit Gandhi',
    rating: 5,
    tags: [],
    text:
      'Great experience! He did a fantastic job cleaning the sofa—looks fresh and almost new. Polite, professional, and hardworking. Totally deserve 5 stars.'
  },
  {
    id: 'rahul-vala',
    name: 'Rahul Vala',
    rating: 5,
    tags: [
      'Excellent service',
      'Fast worker',
      'Reliable',
      'Sanitised equipment',
      'Appliances in good condition',
      'Reasonably priced',
      'No hidden cost'
    ],
    text:
      'Khodal Housekeeping Agency exceeded my expectations with their excellent service. The appliances were in good condition and the equipment was sanitised. The workers were fast, reliable, and there were no hidden costs. All this at a reasonably priced rate.'
  },
  {
    id: 'santosh',
    name: 'Santosh',
    rating: 5,
    tags: [],
    text:
      'I had a good experience with Khodal Housekeeping Agency. The workers were fast and did their job well. They used clean and sanitised equipment, which made me feel safe. The prices were reasonable, and I got good value for my money. My appliances are now in good condition after their work. Overall, I am very satisfied with their service!'
  },
  {
    id: 'nanu',
    name: 'Nanu',
    rating: 5,
    tags: [],
    text:
      'I recently used Khodal Housekeeping Agency and I am very impressed! The service was excellent from start to finish. The workers were fast, completing tasks in no time. Their work was satisfactory, and everything was done perfectly. Plus, they were polite and professional, making the whole experience enjoyable. I highly recommend them for any home needs!'
  },
  {
    id: 'poonam',
    name: 'Poonam',
    rating: 5,
    tags: [],
    text:
      'I recently hired Khodal Housekeeping Agency for some home repairs, and I couldn’t be happier! Their appliances were in excellent condition, ensuring quality work. I was particularly impressed by the sanitised equipment they used, promoting a clean environment. The pricing was reasonable with no hidden costs, making the entire experience transparent and stress-free. Highly recommend!'
  },
  {
    id: 'anil-parmar',
    name: 'Anil Parmar',
    rating: 5,
    tags: [],
    text:
      'My experience with Khodal Housekeeping Agency was excellent! Their service was incredibly helpful and the work was consistently satisfactory. I found them to be reliable, with reasonably priced services and no hidden costs. They used sanitised equipment, ensuring everything remained in good condition. I highly recommend them for home utility and repair needs!'
  },
  {
    id: 'ghanshaym',
    name: 'Ghanshaym',
    rating: 5,
    tags: [],
    text:
      'I had an excellent experience with Khodal Housekeeping Agency. Their appliances were in good condition and their equipment was properly sanitized. The work they did was reliable and satisfactory, providing excellent service with no hidden costs. Additionally, their prices were reasonable. Overall, I was very pleased with the quality of their work and would highly recommend them.'
  },
  {
    id: 'kuldip-gangdiya',
    name: 'Kuldip Gangdiya',
    rating: 5,
    tags: ['Excellent service', 'Satisfactory work', 'Fast worker'],
    text:
      'Khodal Housekeeping Agency provided an excellent service. Their fast workers were polite and professional, delivering satisfactory results. I was impressed with their efficient and reliable home utility and repair services.'
  },
  {
    id: 'meet-soni',
    name: 'Meet Soni',
    rating: 5,
    tags: ['Satisfactory work', 'Helpful', 'Fast worker'],
    text:
      'Khodal Housekeeping Agency provides excellent home utility and repair services. Their efficient technicians are fast workers, delivering satisfactory and helpful work. Whether it’s cleaning or repairs, they get the job done.'
  },
  {
    id: 'simab-k',
    name: 'SIMAB K',
    rating: 5,
    tags: ['Excellent service', 'Satisfactory work', 'Reliable'],
    text:
      'Khodal Housekeeping Agency provided excellent service with polite and professional staff. Their work was satisfactory, reliable, and reasonably priced, offering great value for money. The appliances were in good condition.'
  },
  {
    id: 'dharam-singh-purabiya',
    name: 'Dharam Singh Purabiya',
    rating: 4,
    tags: ['Excellent service', 'Fast worker', 'Sanitised equipment'],
    text:
      'I had a positive experience with Khodal Housekeeping Agency. Their appliances were in good condition and the equipment was well-sanitized, providing excellent value for money. The workers were fast and efficient.'
  }
];

export const BUSINESS_NAME = SITE_BRAND_NAME;
